


class FutuCandleWS {
  public m_ws: WebSocket | null = null
  public m_CoinID: string
  public m_chartINT: string
  public m_callfunc_RTcandleinfo: ((data: KlineEvent) => void) | null = null
  public m_lastVolume: number = 0
  public m_lastTime: number = 0

  private reconnectAttempts: number = 0
  private readonly maxReconnectAttempts = 5 // 최대 재연결 횟수
  private reconnectDelay = 2000 // 재연결 대기 시간 (ms)
  private isConnecting: boolean = false

  constructor() {
    this.m_CoinID = ''
    this.m_chartINT = ''
  }

  // 초기화
  Init(coinID: string, chartINT: string): void {
    this.m_CoinID = coinID.toLowerCase()
    this.m_chartINT = chartINT

    this.connect()
  }

  private connect(): void {
    if (this.isConnecting) return

    this.isConnecting = true
    const wsUrl = process.env.NEXT_PUBLIC_BINANCE_FUTU_SOCKET_URL || ''

    try {
      this.m_ws = new WebSocket(wsUrl)

      this.m_ws.onopen = (event: Event) => {
        // console.log('웹소켓 연결 성공:', event)
        this.isConnecting = false
        this.reconnectAttempts = 0
        this.start()
      }

      this.m_ws.onclose = (event: CloseEvent) => {
        // console.log('웹소켓 연결 해제:', event)
        this.isConnecting = false

        if (event.code !== 1000) {
          this.reconnect()
        }
      }

      this.m_ws.onerror = (event: Event) => {
        // console.error('웹소켓 에러:', event)
        this.isConnecting = false
      }

      this.m_ws.onmessage = (event: MessageEvent) => {
        try {
          const data = JSON.parse(event.data)

          setTimeout(() => {
            if (this.m_callfunc_RTcandleinfo) {
              const klineEvent = data as KlineEvent
              if ('E' in klineEvent) {
                this.m_callfunc_RTcandleinfo(klineEvent)
              }
            }
          }, 0)
        } catch (error) {
          console.error('메시지 파싱 에러:', error)
        }
      }
    } catch (error) {
      console.error('웹소켓 연결 에러:', error)
      this.isConnecting = false
    }
  }

  private reconnect(): void {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.warn('최대 재연결 시도 횟수 도달. 더 이상 재연결하지 않습니다.')
      return
    }

    this.reconnectAttempts++
    // console.log(`웹소켓 재연결 시도 (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)

    setTimeout(() => {
      this.Init(this.m_CoinID, this.m_chartINT)
    }, this.reconnectDelay)
  }

  // 콜백 함수 설정
  SetCallbackFunc(callfunc_RTcandleinfo: (data: KlineEvent) => void): void {
    this.m_callfunc_RTcandleinfo = callfunc_RTcandleinfo
  }

  start(): boolean {
    if (!this.m_ws || this.m_ws.readyState !== WebSocket.OPEN) {
      console.warn('웹소켓이 연결되지 않았습니다.')
      return false
    }

    const packet = JSON.stringify({
      method: 'SUBSCRIBE',
      params: [`${this.m_CoinID}@kline_${this.m_chartINT}`],
      id: 1,
    })

    try {
      this.m_ws.send(packet)
      // console.log('구독 요청 전송:', packet)
      return true
    } catch (error) {
      console.error('구독 요청 전송 실패:', error)
      return false
    }
  }

  // 웹소켓 종료
  stop(): void {
    if (!this.m_ws || this.m_ws.readyState !== WebSocket.OPEN) {
      return
    }

    const packet = JSON.stringify({
      method: 'UNSUBSCRIBE',
      params: [`${this.m_CoinID}@kline_${this.m_chartINT}`],
      id: 1,
    })

    try {
      this.m_ws.send(packet)
      // console.log('구독 해제 요청 전송:', packet)
    } catch (error) {
      console.error('구독 해제 요청 전송 실패:', error)
    }
  }

  close(): void {
    if (this.m_ws) {
      this.stop()
      this.m_ws.close(1000, '정상 종료')
      this.m_ws = null
    }
  }

  // 연결 상태 확인
  IsConnected(): boolean {
    return this.m_ws?.readyState === WebSocket.OPEN
  }
}

export default FutuCandleWS
